<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 3 :</span> แผนงาน
        </div>
   
        <!-- Form 1 -->
        <div>
          <div class="txt-head black--text d-flex justify-space-between mb-3">
            <div>
              1.แผนการดำเนินงาน (จัดทำในรูปเเบบ Project based management)
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
            <Button v-if="!isFinal && !isOIC" theme="6" :disabled="partOneEditMode" @onClick="addNewPlan">
              + เพิ่มแผนดำเนินงาน
            </Button>
          </div>
          <!--   PLAN HEADERS   -->
          <div class="py-5 overflow-x-auto mx-n6 px-6 scroll">
            <div class="d-flex justify-space-between gap-8 px-3 mb-3">
              <div class="flex" style="min-width: 42px; max-width: 42px">
                จัดการ
              </div>
              <div class="flex" style="min-width: 120px; max-width: 120px">
                กิจกรรม
              </div>
              <div class="flex" style="min-width: 61px; max-width: 61px">
                WF
              </div>
              <div
                v-for="(m, ind) in shortMonths"
                :key="ind"
                class="flex"
                style="min-width: 43px; max-width: 43px"
              >
                <div class="text-center">{{ m.month }}</div>
                <div class="text-center">{{ m.year }}</div>
              </div>
              <div class="flex" style="min-width: 43px; max-width: 43px">
                แผนผล
              </div>
              <div
                class="flex text-center"
                style="min-width: 43px; max-width: 43px"
              >
                %
              </div>
            </div>
            <!--   PLAN ITEMS   -->
            <div
              v-if="allPlans && allPlans.length > 0"
              class="d-flex flex-column gap-12"
            >
              <div
                v-for="(item, i) in allPlans"
                :key="i"
                class="plan-card d-flex justify-space-between gap-8"
                :class="{
                  'plan-active':
                    partOneEditMode && tempPlan && tempPlan.temp_index === i,
                }"
              >
           
                <div class="d-flex justify-space-between align-center" style="min-width: 42px; max-width: 42px">
                  <v-btn v-if="!isFinal && !isOIC" small icon @click="editPlan(i)">
                    <Iconify
                      icon="material-symbols:edit"
                      color="var(--theme-color-seven)"
                    ></Iconify>
                  </v-btn>
                  <v-btn v-if="!isFinal && !isOIC" small icon @click="deletePlan(i)">
                    <Iconify
                        icon="material-symbols:delete"
                        color="var(--theme-color-seven)"
                    ></Iconify>
                  </v-btn>
                </div>
                <div class="d-block">
                  <div
                    class="flex two-line"
                    style="min-width: 120px; max-width: 120px; max-height: 45px"
                  >
                    <tooltip-text :text="item.p1_activity_name" />
                  </div>
                </div>
                <div
                  class="flex d-flex justify-space-between"
                  style="min-width: 61px; max-width: 61px; height: 54px"
                >
                  <v-divider vertical></v-divider>
                  <div
                    class="tiny-field tf-active"
                    style="min-width: 40px; max-width: 40px; height: 100%"
                  >
                    {{ item.p1_wf }}
                  </div>
                  <v-divider vertical></v-divider>
                </div>

                <div
                    v-for="(m, ind) in shortMonths"
                    :key="ind"
                    class="flex d-flex flex-column gap-8"
                    style="min-width: 43px; max-width: 43px"
                >
                  <div class="tiny-field">
                    {{
                      item.project_section_plan_month[ind].month_value
                          ? item.project_section_plan_month[ind].month_value
                          : "-"
                    }}
                  </div>
                  <div v-if="isFinal" class="tiny-field">
                    {{
                      item.project_section_plan_month[ind].actual_month_value
                          ? item.project_section_plan_month[ind]
                              .actual_month_value
                          : "-"
                    }}
                  </div>
                </div>
                <div
                  class="flex d-flex flex-column gap-8"
                  style="min-width: 43px; max-width: 43px"
                >
                  <div class="tiny-field">
                    {{
                      item.project_section_plan_month[currIndex]?.month_value ||
                      "-"
                    }}
                  </div>
                  <div v-if="isFinal" class="tiny-field">
                    {{
                      item.project_section_plan_month[currIndex]
                        ?.actual_month_value || "-"
                    }}
                  </div>
                </div>
                <div
                  class="flex d-flex flex-column gap-8"
                  style="min-width: 43px; max-width: 43px"
                >
                  <div class="tiny-field">
                    {{
                      item.project_section_plan_month[shortMonths.length - 1]
                        ?.month_value || "-"
                    }}
                  </div>
                  <div v-if="isFinal" class="tiny-field">
                    {{
                      formatNumber(
                        parseFloat(
                          item.project_section_plan_month[currIndex]
                            ?.actual_month_value * 100
                        ) /
                          parseFloat(
                            item.project_section_plan_month[currIndex]
                              ?.month_value
                          ),
                        2
                      )
                    }}
                  </div>
                </div>
              </div>

              <!--   SUMMARY   -->
              <div class="plan-card">
                <div class="d-flex justify-space-between gap-8">
                  <div
                    class="flex"
                    style="min-width: 42px; max-width: 42px"
                  ></div>
                  <div class="flex" style="min-width: 120px; max-width: 120px">
                    แผนงานถ่วงน้ำหนัก
                  </div>
                  <div
                    class="flex d-flex justify-space-between"
                    style="min-width: 61px; max-width: 61px"
                  >
                    <v-divider vertical></v-divider>
                    <div
                      class="tiny-field"
                      :class="{
                        'theme-color-four tf-error': totalWF() !== '1.00',
                      }"
                      style="min-width: 40px; max-width: 40px"
                    >
                      {{ totalWF() }}
                    </div>
                    <v-divider vertical></v-divider>
                  </div>

                  <div
                    v-for="(m, ind) in shortMonths"
                    :key="ind"
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ weightPlan(ind) }}
                  </div>

                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ weightPlan(currIndex) }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ weightPlan(shortMonths.length - 1) }}
                  </div>
                </div>

                <v-divider class="my-3"></v-divider>

                <div class="d-flex justify-space-between gap-8">
                  <div
                    class="flex"
                    style="min-width: 42px; max-width: 42px"
                  ></div>
                  <div class="flex" style="min-width: 120px; max-width: 120px">
                    ผลการดำเนินงาน
                  </div>
                  <div
                    class="flex d-flex justify-space-between"
                    style="min-width: 61px; max-width: 61px"
                  >
                    <v-divider vertical></v-divider>
                    <div style="min-width: 40px; max-width: 40px"></div>
                    <v-divider vertical></v-divider>
                  </div>
                  <div
                    v-for="(m, ind) in shortMonths"
                    :key="ind"
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ isFinal ? weightPlan(ind, "actual_month_value") : "-" }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal
                        ? weightPlan(currIndex, "actual_month_value")
                        : "-"
                    }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal
                        ? formatNumber(
                            parseFloat(
                              weightPlan(currIndex, "actual_month_value") * 100
                            ) / parseFloat(weightPlan(currIndex)),
                            2
                          )
                        : "-"
                    }}
                  </div>
                </div>

                <v-divider class="my-3"></v-divider>

                <div class="d-flex justify-space-between gap-8">
                  <div class="flex" style="min-width: 42px; max-width: 42px">
                    <v-btn
                      v-if="budget_amount !== 0 && !isFinal && !isOIC"
                      small
                      icon
                      @click="editBudgetPlan()"
                    >
                      <Iconify
                        icon="material-symbols:edit"
                        color="var(--theme-color-seven)"
                      ></Iconify>
                    </v-btn>
                  </div>
                  <div class="flex" style="min-width: 120px; max-width: 120px">
                    แผนการใช้จ่ายจริง
                  </div>
                  <div
                    class="flex d-flex justify-space-between"
                    style="min-width: 61px; max-width: 61px"
                  >
                    <v-divider vertical></v-divider>
                    <div style="min-width: 40px; max-width: 40px"></div>
                    <v-divider vertical></v-divider>
                  </div>
                  <div
                    v-for="(m, ind) in shortMonths"
                    :key="ind"
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      budgetPlans[ind]?.plan_budget_rate
                        ? budgetPlans[ind].plan_budget_rate
                        : "-"
                    }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      budgetPlans[currIndex]?.plan_budget_rate
                        ? budgetPlans[currIndex].plan_budget_rate
                        : "-"
                    }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      budgetPlans[shortMonths.length - 1]?.plan_budget_rate
                        ? budgetPlans[shortMonths.length - 1].plan_budget_rate
                        : "-"
                    }}
                  </div>
                </div>

                <v-divider class="my-3"></v-divider>

                <div class="d-flex justify-space-between gap-8">
                  <div class="flex" style="min-width: 42px; max-width: 42px">
                  </div>
                  <div class="flex" style="min-width: 120px; max-width: 120px">
                    การใช้จ่ายจริง
                  </div>
                  <div
                    class="flex d-flex justify-space-between"
                    style="min-width: 61px; max-width: 61px"
                  >
                    <v-divider vertical></v-divider>
                    <div style="min-width: 40px; max-width: 40px"></div>
                    <v-divider vertical></v-divider>
                  </div>
                  <div
                    v-for="(m, ind) in shortMonths"
                    :key="ind"
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal && budgetPlans[ind]?.use_budget_rate
                        ? formatNumber(budgetPlans[ind].use_budget_rate, 2)
                        : "-"
                    }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal && budgetPlans[currIndex]?.use_budget_rate
                        ? formatNumber(
                            budgetPlans[currIndex].use_budget_rate,
                            2
                          )
                        : "-"
                    }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal
                        ? formatNumber(
                            parseFloat(
                              budgetPlans[currIndex]?.use_budget_rate * 100
                            ) /
                              parseFloat(
                                budgetPlans[currIndex]?.plan_budget_rate
                              ),
                            2
                          )
                        : "-"
                    }}
                  </div>
                </div>

                <v-divider class="my-3" v-if="isFinal"></v-divider>

                <div class="d-flex pl-12" v-if="isFinal">
                  ผลการดำเนินงานในภาพรวม ณ ปัจจุบันเป็นร้อยละ
                  <div
                    class="flex tiny-field ml-4"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ formatNumber(regionMonthValue, 2) }}
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="no-plan-item">ไม่มีข้อมูล</div>
          </div>
        </div>
      </div>
      
      <div v-if="partOneEditMode" id="part-one-edit" class="card-part">
        <div class="d-flex gap-16 mb-3">
          <div>
            <div class="black--text mb-3">กิจกรรม</div>

            <TextField
              theme="3"
              :value="tempPlan.p1_activity_name"
              @onChange="tempPlan.p1_actvity_name = $event"
            ></TextField>
          </div>
          <div>
            <div class="black--text mb-3">WF</div>

            <TextField
              theme="3"
              input-type="decimal"
              :value="tempPlan.p1_wf"
              :error="error_p1_wf"
              @onChange="tempPlan.p1_wf = $event"
            ></TextField>
          </div>
        </div>

        <div class="plan-field-form">
          <div v-for="(month, i) in shortMonths" :key="i">
            <div class="text-center mb-2">
              {{ month.month }} {{ month.year }}
            </div>
            <TextField
              theme="3"
              input-type="decimal-100"
              :error="
                tempPlan.project_section_plan_month[i]?.error ||
                tempPlan.project_section_plan_month[i]?.errorSkipInput
              "
               :disabled="nowIndex(month.month, month.year)"
              :readonly="nowIndex(month.month, month.year)"
              :value="
                isFinal
                  ? tempPlan.project_section_plan_month[i]?.actual_month_value
                  : tempPlan.project_section_plan_month[i]?.month_value
              "
              @onChange="validateInput(i, $event)"
            ></TextField>
          </div>
        </div>

        <div class="d-flex justify-end gap-16">
          <Button min-width="80px" theme="2" @onClick="partOneEditMode = false"
            >ยกเลิก
          </Button>

          <Button min-width="80px" theme="6" @onClick="savePlan"
            >ยืนยัน
          </Button>
        </div>
      </div>
      <div
        v-if="partOneBudgetEditMode"
        id="part-one-budget-edit"
        class="card-part"
      >
        <div class="d-flex gap-16 mb-3">
          {{ isFinal ? "การใช้จ่ายจริง" : "แผนการใช้จ่าย" }} <span class="theme-color-seven txt-normal" style="margin-left: 22px;">(บาท)</span>
        </div>

        <div class="plan-field-form">
          <div v-for="(month, i) in shortMonths" :key="i">
            <div class="text-center mb-2">
              {{ month.month }} {{ month.year }}
            </div>
            <TextField
              v-if="isFinal"
              theme="3"
              inputType="decimal"
               :disabled="nowIndex(month.month, month.year)"
              :readonly="nowIndex(month.month, month.year)"
              :value="tempBudgetPlan[i]?.use_budget"
              @onChange="tempBudgetPlan[i].use_budget = $event"
            ></TextField>
            <TextField
              v-else
              theme="3"
              inputType="decimal"
              isFormat
               :disabled="nowIndex(month.month, month.year)"
              :readonly="nowIndex(month.month, month.year)"
              :value="tempBudgetPlan[i]?.plan_budget"
              @onChange="handleBudgetChange(i, $event)"
            ></TextField>
          </div>
        </div>

        <div class="d-flex justify-end gap-16">
          <Button
            min-width="80px"
            theme="2"
            @onClick="partOneBudgetEditMode = false"
            >ยกเลิก
          </Button>

          <Button min-width="80px" theme="6" @onClick="saveBudgetPlan"
            >ยืนยัน
          </Button>
        </div>
      </div>
    </divcard>

    <!--  FORM 2  -->
      
    <divcard>
      <div class="card-part pt-0">
        <div class="mb-5">
          <div class="txt-head black--text d-flex justify-space-between mb-3">
            <div>
              2. งบประมาณ (รายละเอียดการประเมินค่าใช้จ่ายในโครงการ)
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
            <Button
              v-if="!isFinal && !isOIC"
              theme="6"
              :disabled="partTwoEditMode"
              @onClick="addNewBudget"
            >
              + เพิ่มรายละเอียดงบประมาณ
            </Button>
          </div>

          <div class="d-flex theme-color-eight px-3 mb-3 gap-12">
            <div style="width: 8%">{{ isFinal ? "" : "จัดการ" }}</div>
            <div style="width: 18%">รายการ</div>
            <div style="width: 22%">รายละเอียด</div>
            <div class="text-end" style="width: 14%">
             Unit Cost (บาท)
            </div>
            <div class="text-end" style="width: 14%">
              จำนวน
            </div>
            <div class="text-end" style="width: 9%">
              หน่วย
            </div>
            <div class="text-end" style="width: 15%">งบประมาณ (บาท)</div>
          </div>
          <div class="d-flex flex-column gap-16">
            <div v-for="(item, i) in budgetList" :key="i" class="budget-item">
              <div
                class="d-flex justify-space-between align-center black--text gap-12"
              >
                <div style="width: 8%">
                  <v-btn v-if="!isFinal && !isOIC" small icon @click="editBudget(i)">
                    <Iconify
                      icon="material-symbols:edit"
                      color="var(--theme-color-seven)"
                    ></Iconify>
                  </v-btn>
                  <v-btn v-if="!isFinal && !isOIC" small icon @click="deleteBudget(i)">
                    <Iconify
                      icon="material-symbols:delete"
                      color="var(--theme-color-seven)"
                    ></Iconify>
                  </v-btn>
                </div>
                <div style="width: 18%">{{ item.budget_name }}</div>
                <div
                  style="width: 22%"
                  v-html="item.budget_detail?.replace(/\n/g, '<br>')"
                ></div>
                <div class="text-end" style="width: 14%">
                  {{ formatNumber(item.budget_cost, 2) }}
                </div>
                <div class="text-end" style="width: 14%">
                  {{ formatNumber(item.budget_amount, 2) }}
                </div>
                <div class="text-end" style="width: 9%">
                  {{ item.budget_unit }}
                </div>
                <div class="text-end" style="width: 15%">
                  {{ formatNumber(item.budgets, 2) }} บาท
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="budgetList && budgetList.length > 0"
          class="d-flex flex-column gap-12 px-12 mb-5"
        >
          <div class="d-flex justify-space-between">
            <div class="black--text">รวมลำดับที่ 1-{{ budgetList.length }}</div>
            <div class="theme-color-one">
              {{
                formatNumber(
                  budgetList
                    .map((x) => x.budgets)
                    .reduce((a, b) => parseFloat(a) + parseFloat(b), 0),
                  2
                )
              }}
              บาท
            </div>
          </div>
        </div>

      </div>

      <div
        v-if="partTwoEditMode && !isFinal"
        id="part-two-edit"
        class="card-part"
      >
        <div class="d-flex gap-16 mb-3" style="align-items: end">
          <div>
            <div class="black--text mb-3">รายการ</div>

            <TextField
              theme="3"
              :value="tempBudget?.budget_name"
              @onChange="tempBudget.budget_name = $event"
            ></TextField>
          </div>

          <div>
            <div class="black--text mb-3">
             Unit Cost
            </div>
            <TextField
              theme="3"
              input-type="decimal"
              isFormat
              :value="tempBudget?.budget_cost"
              @onChange="tempBudget.budget_cost = $event"
            ></TextField>
          </div>

          <div>
            <div class="black--text mb-3">
              จำนวน
            </div>

            <TextField
              theme="3"
              input-type="decimal"
              isFormat
              :value="tempBudget.budget_amount"
              @onChange="tempBudget.budget_amount = $event"
            ></TextField>
          </div>

          <div>
            <div class="black--text mb-3">
             หน่วย
            </div>
            <TextField
              theme="3"
              :value="tempBudget.budget_unit"
              isFormat
              @onChange="tempBudget.budget_unit = $event"
            ></TextField>
          </div>
          
        </div>
        <div style='width:215px;'>
            <div class="black--text mb-3">
             งบประมาณทั้งหมด
            </div>
            <TextField
              theme="3"
              input-type="decimal"
              :value="tempBudget?.budgets"
              isFormat
              @onChange="tempBudget.budgets = $event"
            ></TextField>
          </div>
        
        <div>
          
          <div>
            <div class="black--text mb-3">รายละเอียด</div>

            <TextArea
              theme="3"
              :value="tempBudget.budget_detail"
              @onChange="tempBudget.budget_detail = $event"
            ></TextArea>
          </div>
        </div>

        <div class="d-flex justify-end gap-16">
          <Button min-width="80px" theme="2" @onClick="partTwoEditMode = false"
            >ยกเลิก
          </Button>

          <Button min-width="80px" theme="6" @onClick="saveBudget"
            >ยืนยัน
          </Button>
        </div>
      </div>
    </divcard>
    <divcard v-if="!isFinal">
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            3. ขั้นตอนการดำเนินงาน
            <span class="theme-color-seven txt-normal" style="text-indent: 16px"
              >(โปรดระบุ)</span
            >
          </div>
          <Wysiwyg
            theme="3"
            :value="form.progress_information"
            @onChange="setFormField('progress_information', $event)"
          ></Wysiwyg>
        </div>
      </div>
    </divcard>

    
  </div>
</template>

<script>
import TextField from "../../../components/input/TextField";
import TextArea from "../../../components/input/TextArea";
import SwitchInset from "../../../components/input/SwitchInset";
import AutoBox from "../../../components/input/AutoBox";
import Button from "../../../components/input/Button";
import CheckBox from "../../../components/input/CheckBox";
import { eventBus, formatNumber } from "../../../plugins/global-funcs";
import { mapState } from "vuex";
import { format } from "date-fns";
import { th } from "date-fns/locale";
import Wysiwyg from "../../../components/input/Wysiwyg.vue";

export default {
  name: "AFormPlan",
  components: {
    TextField,
    TextArea,
    SwitchInset,
    AutoBox,
    Wysiwyg,
    CheckBox,
    Button,
  },
  props: {
    masterData: {
      default: () => ({}),
    },
    isSameId: {
      default: false,
    },
  },
  data() {
    return {
      formatNumber,
      form: {},
      tempPlan: {},
      tempBudget: {},
      tempProgressPlan: {},
      budgetList: [],
      
      budgetPlans: [],
      budget_plan_prototype: [],
      partOneEditMode: false,
      partTwoEditMode: false,
      partOneBudgetEditMode: false,
      expanded: false,
      allPlans: [],
      allPlansFormB: [],
      allEventsName: [
        "ส่งเสริมคุณภาพการออกแบบและพัฒนา",
        "พัฒนาระบบด้านเทคโนโลยีของหุ่นยนต์",
      ],
      shortMonths: [],
      plan_prototype: {
        p1_wf: "",
        project_section_plan_month: [],
      },
      progressPlan_prototype: {
        plan: [],
      },
      error_p1_wf: false,
      allProgressPlan: [
        {
          plan: [2, 3, 4, 5],
        },
        {
          plan: [5, 6],
        },
        {
          plan: [7, 8, 9, 10],
        },
      ],
      total_plan_budget_rate: [],
      total_use_budget_rate: [],
      planBudgets: {},
      budget_amount: 0,
      currIndex: 0,
      fiscalYear: new Date().getFullYear() + 543,
    };
  },
  computed: {
    ...mapState({
      PlanForm: (state) => state.AForm.PlanForm,
      isOIC: (state) => state.Auth.User.user_type === "สป.อว.",
      isRSP: (state) => state.Auth.User.user_type === "RSP",
    }),
    isFinal() {
      return (
        this.$route.query.doc_type && this.$route.query.doc_type === "progress"
      );
    },
  },
  created() {
    console.log("AFormPlan created");
    this.clearTempPlan();
    this.clearTempProgressPlan();
    if (this.masterData.form_b) {
      this.setData();
    }
    this.calcBudgetAmount();

    // set begin budget year month
    this.setupBudgetYearMonth();
    if (this.budgetPlans.length === 0) {
      console.log('budget_plan_prototype', this.budget_plan_prototype);
      this.budgetPlans = this.budget_plan_prototype;
    }
    this.currIndex = this.getCurrIndex();
    eventBus.$on("aFormPlan", () => {
      eventBus.$emit("aFormPlanSend", {
        ...this.form,
        project_section_plan_p1: this.allPlans.map((x) => ({
          ...x,
          percent: undefined,
        })),
        project_section_plan_p1_budget: this.budgetPlans,
        project_section_budget_df: this.budgetList,
        budget_amount: this.budget_amount,
      });
    });
    eventBus.$on("aFormPlanSetData", () => this.setData());
  },
  methods: {
    setData() {
      console.log("setsssData",this.masterData.form_b.project_section_plan
          ?.project_section_plan_p1_budget);
      this.budgetPlans =
        this.masterData.form_b.project_section_plan
          ?.project_section_plan_p1_budget || [];
      this.allPlans =
        this.masterData.form_b.project_section_plan?.project_plan_p1 || [];
      this.allPlansFormB = this.mapFormBPlanData(
        this.masterData.form_b.form_b || []
      );
      for (const x of this.allPlans) {
        x.percent = this.getLastProgress(x.project_section_plan_month);
      }
      if (
        this.masterData.form_b.project_section_plan?.project_section_budget_df &&
        this.masterData.form_b.project_section_plan.project_section_budget_df.length > 0
      ) {
        this.budgetList = this.masterData.form_b.project_section_plan?.project_section_budget_df;
      }
      this.form = this.masterData.form_b.form_ab_project_info;
      this.fiscalYear = this.masterData.form_b.fiscal_year;
    },
    setFormField(field, val) {
      this.form[field] = val;
      this.$forceUpdate();
    },
    editBudgetPlan() {
      this.partOneBudgetEditMode = false;
      this.tempBudgetPlan = this.removeVModel(this.budgetPlans);
      this.partOneBudgetEditMode = true;
      this.$forceUpdate();
    },
    mapFormBPlanData(form_b_list) {
      let plan_data = [];
      let wf = 0;
      let plan_count = 0;
      form_b_list.forEach((form_b) => {
        if (
          form_b.project_section_plan.project_section_plan_p1_budget &&
          form_b.project_section_plan.project_section_plan_p1_budget.length > 0
        )
          plan_count++;
      });
      if (plan_count === 0) wf = 1.0;
      else wf = (1 / plan_count).toFixed(2);

      let total_amount = 0;
      let total_plan_budget_month = [];
      let total_use_budget_month = [];
      let month_length = 0;
      form_b_list.forEach((form_b, index) => {
        if (index === form_b_list.length - 1)
          wf = (1.0 - wf * (form_b_list.length - 1)).toFixed(2);
        total_amount =
          parseFloat(total_amount) + parseFloat(form_b.budget_amount);
        if (
          form_b.project_section_plan.project_section_plan_p1_budget &&
          form_b.project_section_plan.project_section_plan_p1_budget.length > 0
        ) {
          let plan = {
            p1_activity_name: form_b.plan.plan_master.plan_name_th,
            p1_wf: wf,
            project_section_plan_month:
              form_b.project_section_plan.project_section_plan_p1_budget,
            percent:
              form_b.project_section_plan.project_section_plan_p1_budget.slice(
                -1
              ).month_value,
          };
          month_length = plan.project_section_plan_month.length;
          console.log('plan.project_section_plan_month', plan.project_section_plan_month)
          for(let i = 0; i < month_length; i++) {
            if(!total_plan_budget_month[i]) total_plan_budget_month[i] = 0.00
            if(!total_use_budget_month[i]) total_use_budget_month[i] = 0.00
            total_plan_budget_month[i] = (parseFloat(total_plan_budget_month[i]) + parseFloat(plan.project_section_plan_month[i].plan_budget_sum)).toFixed(2)
            total_use_budget_month[i] = (parseFloat(total_use_budget_month[i]) + parseFloat(plan.project_section_plan_month[i].use_budget_sum)).toFixed(2)

          }
          console.log('total_use_budget_month1', total_use_budget_month)
          plan_data.push(plan)
        }
      });

      for (let ind = 0; ind < month_length; ind++) {
        if (
          parseFloat(total_use_budget_month[ind]) > 0 &&
          parseFloat(total_plan_budget_month[ind]) > 0
        )
          total_use_budget_month[ind] = (
            (parseFloat(total_use_budget_month[ind]) /
              parseFloat(total_plan_budget_month[ind])) *
            100
          ).toFixed(2);
        else total_use_budget_month[ind] = "0.00";
        total_plan_budget_month[ind] = (
          (parseFloat(total_plan_budget_month[ind]) /
            parseFloat(total_amount)) *
          100
        ).toFixed(2);
      }
      console.log("total_use_budget_month2", total_use_budget_month);
      this.total_plan_budget_rate = total_plan_budget_month;
      this.total_use_budget_rate = total_use_budget_month;
      return plan_data;
    },
    addNewPlan() {
      // clear temp index
      this.clearTempPlan();
      if (this.partOneEditMode) {
        this.$vuetify.goTo("#part-one-edit");
      } else {
        this.tempPlan = {
          ...this.tempPlan,
          isNew: true,

        }
        this.partOneEditMode = true;
      }
    },
    editPlan(i) {
      this.partOneEditMode = false;
      this.tempPlan = {
        ...this.removeVModel(this.allPlans[i]),
        temp_index: i,
      };
      this.partOneEditMode = true;
      this.$forceUpdate();
    },
    savePlan() {
      // complete 2 pos decimal format
      this.completeTwoPosDecimal("tempPlan");

      // validate WF
      if (!this.validateWF()) return;
      // validate conditions
      let before_value = 0;
      let error = [];
      let field_name = "month_value";
      for (const x of this.tempPlan.project_section_plan_month) {
        if (this.isFinal) field_name = "actual_month_value";
        if (!isNaN(x[field_name]) && parseFloat(x[field_name]) < before_value) {
          x.error = true;
          if (this.isFinal) {
            error.push(
              "Value must be greater than previous actual month value"
            );
          } else {
            error.push("Value must be greater than previous month value");
          }
        } else {

          x.error = undefined;
          if (x.errorSkipInput) {
            error.push("Cannot skip the input between input values");
          }
        }
        before_value = parseFloat(x[field_name]);
      }
      this.$forceUpdate();
      if (error.length > 0) {
        console.log(error);
        return;
      }

      let lastProgress = this.getLastProgress(
        this.tempPlan.project_section_plan_month
      );
      
      if (!this.tempPlan.isNew) {
        // EDIT
        console.log('new');
        this.allPlans[this.tempPlan.temp_index] = {
          ...this.tempPlan,
          percent: lastProgress,
          temp_index: undefined,
        };
      } else {
        // ADD
        console.log('this.allPlan', this.allPlan);
        this.allPlans.push({
          p1_activity_name: this.tempPlan.p1_actvity_name,
          p1_wf: this.tempPlan.p1_wf,
          project_section_plan_month: this.tempPlan.project_section_plan_month,
          percent: lastProgress,
        });

      }

      this.clearTempPlan();
      this.mapWFData();
      this.partOneEditMode = false;
    },
    mapWFData() {
      
      this.shortMonths.forEach((m, i) => {
        this.budgetPlans[i].month_value = this.weightPlan(i);
        if (this.isFinal)
          this.budgetPlans[i].actual_month_value = this.weightPlan(
            i,
            "actual_month_value"
          );
      });

    },
    clearTempPlan() {
      this.tempPlan = this.removeVModel(this.plan_prototype);
      this.error_p1_wf = false;
      this.$forceUpdate();
    },
    removeVModel(item) {
      return JSON.parse(JSON.stringify(item));
    },
    getLastProgress(items) {
      items = this.removeVModel(items);
      if (items && typeof items === "object" && items.length > 0) {
        for (const x of items.reverse()) {
          if (!!x.month_value && x.month_value !== "-") {
            return x.month_value;
          }
        }
      }
      return "-";
    },
    completeTwoPosDecimal(tempName) {
      let i = 0;
      let temp = [];
      let value = "";
      if (tempName === "tempPlan") {
      console.log('6');

        temp = this[tempName].project_section_plan_month;
        value = this.isFinal ? "actual_month_value" : "month_value";
      } else {
        temp = this[tempName];
        value = this.isFinal ? "use_budget_rate" : "plan_budget_rate";
      }

      for (const x of temp) {
        console.log('x',x);
        x.errorSkipInput = undefined;
        if (!x[value] || isNaN(x[value])) {
          x[value] = null;
          if (i > 0) {
            let hasSomeProgressBefore = false;
            let hasSkipInput = false;
            for (let ind = 0; ind < i; ind++) {
              if (temp[ind][value]) {
                hasSomeProgressBefore = true;
                for (let lastInd = temp.length - 1; lastInd > i; lastInd--) {
                  if (!!temp[lastInd][value]) hasSkipInput = true;
                }
              }
            }

            if (hasSomeProgressBefore) x[value] = "100.00";
            if (tempName === "tempBudgetPlan") x[value] = "0";

            if (hasSkipInput) {
              x[value] = null;
              x.errorSkipInput = true;
            }
          }

        } else {

          // no decimal case
          if (!x[value].toString().includes(".")) {
            x[value] += ".00";
          } else {
            // decimal case
            let y = x[value].toString().split(".");
            if (!y[0] && y[0] != "0") {
              y[0] = "0";
            }
            if (!y[1] && y[1] != "0") {
              y[1] = "00";
            }
            // fill zero for 2 position decimal
            if (y.length > 1 && y[1].length === 1) {
              y[1] = y[1].toString() + "0"; // add 0 as string
            }
            // remove after 2 position decimal
            if (y.length > 1 && y[1].length > 2) {
              y[1] = y[1].substring(0, 2);
            }
            x[value] = y[0] + "." + y[1];
            if (x[value] === "0.00") x[value] = null;
          }
        }

        i++;
      }
    },
    validateWF() {
      let error = [];
      let total = 0;
      let editCase =
        !!this.tempPlan.temp_index || this.tempPlan.temp_index === 0;

      // total is 1.00
      if (this.allPlans.length > 0) {
        if (this.allPlans.length === 1) {
          total = this.allPlans[0].p1_wf;
          if (editCase) total = 0;
        } else {
          if (editCase) {
            total = this.allPlans
              .filter((x, i) => i !== this.tempPlan.temp_index)
              .map((x) => x.p1_wf)
              .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
          } else {
            total = this.allPlans.reduce(
              (a, b) => parseFloat(a.p1_wf) + parseFloat(b.p1_wf),
              0
            );
          }
        }

        if (parseFloat(total) >= 1) {
          error.push("WF value cannot over exceed 1.00");
        }
      }

      if (!this.tempPlan.p1_wf || isNaN(this.tempPlan.p1_wf)) {
        error.push("WF value is not correct");
      } else {
        // no decimal case
        console.log('tempPlan');
        
        if (!this.tempPlan.p1_wf.toString().includes(".")) {
          this.tempPlan.p1_wf += ".00";
        } else {
          // decimal case
          let y = this.tempPlan.p1_wf.toString().split(".");
          if (!y[0] && y[0] != "0") {
            y[0] = "0";
          }
          if (!y[1] && y[1] != "0") {
            y[1] = "00";
          }
          // fill zero for 2 position decimal
          if (y.length > 1 && y[1].length === 1) {
            y[1] = y[1].toString() + "0"; // add 0 as string
          }
          // remove after 2 position decimal
          if (y.length > 1 && y[1].length > 2) {
            y[1] = y[1].substring(0, 2);
          }
          this.tempPlan.p1_wf = y[0] + "." + y[1];
          if (this.tempPlan.p1_wf === "0.00") {
            error.push("WF value is not correct");
          }
        }
        if (this.tempPlan.p1_wf > 1) {
          error.push("WF value must less or equal 1.00");
        }
        console.log('tempPlan end');

      }

      if (parseFloat(total) + parseFloat(this.tempPlan.p1_wf) > 1) {
        error.push("WF total value must equal 1.00");
      }

      if (error.length > 0) {
        console.log(error);
        this.error_p1_wf = true;
      } else {
        this.error_p1_wf = false;
      }
      this.$forceUpdate();

      return !this.error_p1_wf;
    },
    deletePlan(i) {
      this.allPlans.splice(i, 1);
      this.$forceUpdate();
    },
    totalWF() {
      if (!this.allPlans || this.allPlans.length === 0) return "-";
      let total = this.allPlans
        .map((x) => x.p1_wf)
        .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    weightPlan(index, field = "month_value") {
      let total = [];
      for (const x of this.allPlans) {
        let result = x.project_section_plan_month[index]
          ? parseFloat(x.project_section_plan_month[index][field] * x.p1_wf)
          : 0;
        if (!isNaN(result)) {
          total.push(result);
        }
      }
      if (total.length > 0) {
        total = total.reduce((a, b) => a + b, 0);
      } else {
        total = "-";
      }
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    getCurrIndex() {
      let ind = 0;
      for (const x of this.allPlans) {
        let i = 0;
        // console.log("x", x);
        for (const y of x.project_section_plan_month) {
          // console.log("y", y);
          let correctIndex = this.isInCorrectRange(y, i);
          if (typeof correctIndex !== "boolean") return correctIndex;
          i++;
        }
        ind++;
      }
    },
    isInCorrectRange(item, index = null) {
      let today = new Date();
      let currentMonth = today.getMonth();
      let thisMonth = new Date(item.year_month).getMonth();

      let isCorrectCase = thisMonth === currentMonth;

      // for return active yearMonth index
      if (isCorrectCase && index !== null) return index;

      return isCorrectCase;
    },
    totalWFFormB() {
      if (!this.allPlansFormB || this.allPlansFormB.length === 0) return "-";
      let total = this.allPlansFormB
        .map((x) => x.p1_wf)
        .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    weightPlanFormB(index, field = "month_value") {
      let total = [];
      for (const x of this.allPlansFormB) {
        let result = parseFloat(
          x.project_section_plan_month[index][field] * x.p1_wf
        );
        if (!isNaN(result)) {
          total.push(result);
        }
      }
      if (total.length > 0) {
        total = total.reduce((a, b) => a + b, 0);
      } else {
        total = "-";
      }
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    addNewBudget() {
      if (this.partTwoEditMode) {
        // clear temp index
        this.tempBudget = {};
        this.$vuetify.goTo("#part-two-edit");
      } else {
        this.partTwoEditMode = true;
      }
      this.tempBudget = {
        ...this.tempBudget,
        isNew : true,
        budgets : null,
        budget_unit : null,
        budget_cost : null,
        budget_amount : null,
      }
      // this.tempBudget?.budgets = '0';
      this.$forceUpdate();
    },
    deleteBudget(index) {
      this.budgetList.splice(index, 1);
      this.calcBudgetAmount();
      this.calcBudgetPlanRate("budgetPlans");
    },
    saveBudget() {
      this.partTwoEditMode = false;
      if (this.tempBudget.tempIndex !== undefined) {
        this.budgetList[this.tempBudget.tempIndex] = this.removeVModel(
          this.tempBudget
        );
      } else {
        this.budgetList.push(this.tempBudget);
      }
      this.tempBudget = {};

      this.calcBudgetAmount();
      this.calcBudgetPlanRate("budgetPlans");
      this.$forceUpdate();
    },
    saveBudgetPlan() {
      // // validate form ต้องกรอกอย่างน้อย 1 รายการ และต้องไม่เป็น 0
      // if (
      //   this.tempBudgetPlan.filter((x) => x.plan_budget !== "").length === 0 ||
      //   this.tempBudgetPlan.filter((x) => x.plan_budget != 0).length === 0
      // ) {
      //   this.$store.commit("General/setModal", {
      //     theme: "warning",
      //     title: "ข้อมูลไม่ครบถ้วน ?",
      //     text: "กรุณากรอกข้อมูลอย่างน้อย 1 รายการ และต้องไม่เป็น 0",
      //     buttonText: "OK",
      //     showCancel: false,
      //   });
      //   return;
      // }

      // // validate ผลรวมแผนการใช้จ่ายต้องเท่ากับงบประมาณที่กำหนด
      // if (
      //   this.tempBudgetPlan
      //     .map((x) => parseFloat(x.plan_budget ? x.plan_budget : 0))
      //     .reduce((a, b) => a + b, 0) !==
      //   this.budgetList
      //     .map((x) => parseFloat(x.budget_amount_rsp))
      //     .reduce((a, b) => a + b, 0)
      // ) {
      //   this.$store.commit("General/setModal", {
      //     theme: "warning",
      //     title: "ข้อมูลไม่ถูกต้อง ?",
      //     text: "ผลรวมแผนการใช้จ่ายต้องเท่ากับงบประมาณที่กำหนด",
      //     buttonText: "OK",
      //     showCancel: false,
      //   });
      //   return;
      // }

      this.calcBudgetPlanRate();
      // complete 2 pos decimal format
      // this.completeTwoPosDecimal('tempBudgetPlan')

      // validate conditions
      let before_value = 0;
      let totalBudget = 0;
      let error = [];
      for (const x of this.tempBudgetPlan) {
        before_value = parseFloat(x.plan_budget);
        totalBudget += parseFloat(x.plan_budget);
      }
      this.$forceUpdate();
      if (totalBudget > this.budget_amount && !this.isFinal) {
        this.$store.commit("General/setModal", {
          theme: "error",
          title: "บันทึกไม่สำเร็จ",
          text: "แผนการใช้จ่ายเกินงบประมาณ ไม่สามารถบันทึกได้",
          buttonText: "OK",
          showCancel: false,
        });
        return;
      }
      if (error.length > 0) {
        console.log(error);
        return;
      }

      this.budgetPlans = this.tempBudgetPlan;

      this.partOneBudgetEditMode = false;
    },
    editBudget(i) {
      this.partTwoEditMode = false;
      this.tempBudget = {
        ...this.removeVModel(this.budgetList[i]),
        tempIndex: i,
        isNew: false,
      };
      this.partTwoEditMode = true;
      this.$forceUpdate();
    },
    calcBudgetPlanRate(objectName = "tempBudgetPlan") {
      let i = 0;
      let field_name =
        this.isFinal && objectName === "tempBudgetPlan"
          ? "use_budget"
          : "plan_budget";
      this[objectName].forEach((budget) => {
        if (!budget[field_name]) budget[field_name] = 0;
        if (i == 0) {
          budget[field_name + "_sum"] = parseFloat(budget[field_name]);
        } else {
          budget[field_name + "_sum"] =
            parseFloat(budget[field_name]) +
            parseFloat(this[objectName][i - 1][field_name + "_sum"]);
        }
        const exactRate = (parseFloat(budget[field_name + "_sum"]) / parseFloat(this.budget_amount)) * 100;

        budget[field_name + "_rate"] = (Math.floor(exactRate * 100) / 100).toFixed(2);
        budget[field_name + "_sum"] = budget[field_name + "_sum"].toFixed(2);
        i++;
      });
      console.log("after calc budget rate", this.tempBudgetPlan);
    },
    calcBudgetAmount() {
      this.budget_amount = this.budgetList
        .map((x) => parseFloat(x.budgets))
        .reduce((a, b) => a + b, 0);
    },
    addNewPlanDetail() {
      this.clearTempProgressPlan();
      this.partThreeEditMode = true;
    },
    saveProgressPlan() {
      let error = [];
      if (this.tempProgressPlan.plan.length === 0) {
        error.push("Select at least 1 month for planning");
        return;
      }
      if (this.tempProgressPlan.temp_index !== undefined) {
        // EDIT
        this.allProgressPlan[this.tempProgressPlan.temp_index] = {
          ...this.tempProgressPlan,
          temp_index: undefined,
        };
      } else {
        // ADD
        this.allProgressPlan.push(this.tempProgressPlan);
      }
      this.clearTempProgressPlan();
      this.partThreeEditMode = false;
    },
    progressPlanCheck(key) {
      if (this.tempProgressPlan.plan.includes(key)) {
        this.tempProgressPlan.plan = this.tempProgressPlan.plan.filter(
          (x) => x !== key
        );
      } else {
        this.tempProgressPlan.plan.push(key);
      }
    },
    clearTempProgressPlan() {
      this.tempProgressPlan = this.removeVModel(this.progressPlan_prototype);
      this.$forceUpdate();
    },
    editProgressPlan(index) {
      this.partThreeEditMode = false;
      this.tempProgressPlan = {
        ...this.removeVModel(this.allProgressPlan[index]),
        temp_index: index,
      };
      this.partThreeEditMode = true;
      this.$forceUpdate();
    },
    setupBudgetYearMonth() {
      let ym = new Date((this.fiscalYear - 544).toString() + "-10");
      let countMonths = 12;
      if (this.isFinal && this.masterData.form_b?.progress_month && this.masterData.form_b?.progress_month > 12) {
        countMonths += this.masterData.form_b.progress_month - 12;
      }
      for (let i = 0; i < countMonths; i++) {
        this.shortMonths.push({
          key: i + 1,
          month: format(ym, "MMM", { locale: th }),
          year: (parseInt(ym.toISOString().substr(0, 7).split("-")[0]) + 543)
            .toString()
            .slice(2),
        });
        this.plan_prototype.project_section_plan_month.push({
          year_month: ym.toISOString().substr(0, 7),
          month_value: "",
        });
        this.budget_plan_prototype.push({
          year_month: ym.toISOString().substr(0, 7),
          month_value: "",
          plan_budget: "",
          plan_budget_rate: "",
        });
        ym = new Date(ym.setMonth(ym.getMonth() + 1));
      }
    },
    validateInput(index, value) {
      let field_name = "month_value";
      if (this.isFinal) field_name = "actual_month_value";
      if (!isNaN(value) && value >= 0 && value <= 100) {
        // if (index > 0) {
        //   let previousValue = this.tempPlan.project_section_plan_month[index - 1]?.month_value;
        //   if (previousValue && value >= previousValue) {
        //     this.$set(this.tempPlan.project_section_plan_month[index], 'month_value', value);
        //   } else {
        //     this.$set(this.tempPlan.project_section_plan_month[index], 'month_value', previousValue);
        //   }
        // } else {
        this.$set(
          this.tempPlan.project_section_plan_month[index],
          field_name,
          value
        );
        // }
      } else {
        if (!isNaN(value)) {
          if (value > 100) {
            this.$set(
              this.tempPlan.project_section_plan_month[index],
              field_name,
              100
            );
          } else {
            this.$set(
              this.tempPlan.project_section_plan_month[index],
              field_name,
              0
            );
          }
        } else {
          this.$set(
            this.tempPlan.project_section_plan_month[index],
            field_name,
            null
          );
        }
      }
    },
    handleBudgetChange(index, value) {
      if (!isNaN(value) && value >= 0) {
        this.$set(this.tempBudgetPlan[index], "plan_budget", value);
        this.$forceUpdate();
      }
    },
      nowIndex(month, year) {
      
        const thaiShortMonthMap = {
          'ม.ค.': 0, 'ก.พ.': 1, 'มี.ค.': 2, 'เม.ย.': 3,
          'พ.ค.': 4, 'มิ.ย.': 5, 'ก.ค.': 6, 'ส.ค.': 7,
          'ก.ย.': 8, 'ต.ค.': 9, 'พ.ย.': 10, 'ธ.ค.': 11
        };
        const monthNumber = thaiShortMonthMap[month];
        if (monthNumber === undefined) return false; // fail-safe

        const buddhistYear = parseInt(year); // 68
        const gregorianYear = buddhistYear + 2000 - 543; // 68 + 2000 - 543 = 1525 (wrong) ❌

        // Correct conversion:
        const currentYear = new Date().getFullYear(); // e.g., 2025
        const buddhistCurrentYear = currentYear + 543; // e.g., 2568

        const yearFull = (buddhistYear > 2500) ? buddhistYear - 543 : buddhistYear + 2500 - 543;
        // Or easier if always 2-digit: assume 68 => 2568 => 2025
        const yearParsed = buddhistYear + 2500 - 543; // 2025

        const planDate = new Date(yearParsed, monthNumber, 1);
        const currentMonthStart = new Date();
        currentMonthStart.setDate(1);
        currentMonthStart.setHours(0, 0, 0, 0);

        return planDate < currentMonthStart;
      }
  },
};
</script>

<style scoped lang="scss">
.budget-item,
.summary-plan {
  background: #ffffff;
  box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  padding: 12px;
}

.summary-plan {
  min-height: 78px;
}

.remark-box {
  color: var(--theme-color-seven);
  background: #fafafa;
  border-radius: 20px;
  padding: 12px;
  font-size: 10px;
}

.plan-card {
  background: #ffffff;
  box-shadow: 1px 1px 18px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  border: 1px solid transparent;
  padding: 12px;
  min-width: max-content;
  &.plan-active {
    border: 1px solid var(--theme-color-seven);
  }
}

.plan-field-form {
  /* User input values. */
  --grid-layout-gap: 16px;
  --grid-column-count: 6;
  --grid-item--min-width: 130px;

  /* Calculated values. */
  --gap-count: calc(var(--grid-column-count) - 1);
  --total-gap-width: calc(var(--gap-count) * var(--grid-layout-gap));
  --grid-item--max-width: calc(
    (100% - var(--total-gap-width)) / var(--grid-column-count)
  );

  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(max(var(--grid-item--min-width), var(--grid-item--max-width)), 1fr)
  );
  grid-gap: var(--grid-layout-gap);
}

.plan-slot > div {
  transition: background-color 400ms;
  background-color: #fff;
  height: 20px;
}
.plan-slot .progress-plan-mark {
  background-color: var(--theme-color-one);
  min-width: 45px;
  display: flex;
  align-items: center;
  padding-top: 1px;
  .v-divider {
    border-color: #fff;
  }
}

.progress-plan-mark.start-point {
  border-radius: 30px 0 0 30px;
  padding-left: 4px;
}

.progress-plan-mark.end-point {
  border-radius: 0 30px 30px 0;
  padding-right: 6px;
}

.arrow-right {
  display: none;
}
.end-point .arrow-right {
  display: unset;
  font-family: "Tahoma", sans-serif;
  margin-left: -8px;
  margin-top: -3px;
  user-select: none;
}
</style>
